var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPig = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#003865",
    fillRule: "evenodd",
    d: "M4.493 3c1.458-.02 2.633.35 3.5 1.116l.113.106.063-.016a8.134 8.134 0 0 1 1.458-.198L10 4c3.428 0 6.302 2.114 6.89 4.932.557-.188 1.04-.75 1.103-1.354L18 7.446h1c0 1.17-.91 2.237-2 2.495V10c0 1.498-.642 2.904-1.767 3.988L15 14.2V17h-3v-1.249l-.301.071a8.1 8.1 0 0 1-1.353.17L10 16c-.579 0-1.148-.06-1.698-.177L8 15.75V17H5v-2.801l-.053-.044a6.194 6.194 0 0 1-1.005-1.144L3.935 13H2V8h1.398l.106-.242a5.88 5.88 0 0 1 1.092-1.574l.024-.026-.751-3.15Zm.645 1.022.588 2.461-.211.199a4.82 4.82 0 0 0-1.296 1.977L4.105 9 3 9V12h1.49l.147.242c.3.496.699.95 1.178 1.339l.185.15L6 16H7l.001-1.628.666.235c.731.258 1.52.393 2.333.393.813 0 1.602-.135 2.334-.393l.666-.235L13 16H14v-2.27l.186-.15C15.342 12.641 16 11.361 16 10c0-2.741-2.67-5-6-5-.658 0-1.303.088-1.915.26l-.3.083-.207-.231c-.543-.606-1.299-.966-2.287-1.076l-.153-.014ZM7 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm3-2c1.13 0 2.204.3 3.074.841l.213.14-.572.821C11.981 7.291 11.022 7 10 7c-.369 0-.73.038-1.078.111l-.287.07-.265-.965.035-.01A6.17 6.17 0 0 1 10 6Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPig);
export default ForwardRef;